import LoadEnvVar from "./environment";

export const API_BASE_URL = LoadEnvVar.asUrl("REACT_APP_API_BASE_URL");
export const API_OAUTH_CLIENT_ID = LoadEnvVar.asUrl("REACT_APP_OAUTH_CLIENT_ID");
export const API_OAUTH_CLIENT_SECRET = LoadEnvVar.asUrl("REACT_APP_OAUTH_CLIENT_SECRET");

export enum Routes {
  HOME = "/",
  LOGIN = "/login",
  PRODUCTS = "/product",
  SOBRE_WALIX = "/sobre-walix",
  OPERADORES = "/operadores",
}

export enum ApiEndpoints {
  OAUTH_TOKEN = "/auth/token/",
  OAUTH_VALIDATE_TOKEN = "/api/v1/test/",
  USERS_TO_SUSPEND = "/api/v1/users-to-suspend/",
}
